//list the intervention ids where correctness of prompt responses needs to be considered
//when giving feedback on intervention status during the observation
export const intvPromptResponsesWhereCorrectnessMatters = ["intv-airway-patency-technique-suction-airway",
"intv-insert-advanced-airway", "intv-surgical-cricothyrotomy", "intv-nasotracheal-intubation", 
"intv-orotracheal-intubation", "intv-sedation-assisted-intubation", "intv-insert-advanced-airway",
"intv-supplemental-oxygen-device-nasal-cannula", "intv-supplemental-oxygen-device-non-rebreather-mask",
"intv-pleural-decompression", "intv-ventilation-technique-bag-valve-mask", "intv-control-severe-bleeding-technique-2nd-tourniquet",
"intv-control-shock-technique-keep-patient-warm", "intv-establish-iv", "intv-control-shock-technique-administer-iv-boluses",
"intv-prepare-and-administer-pain-nausea-vomiting-medications", "intv-prepare-amputated-part", ]


// define KR aggregates: if any in array exist as 2nd args can remove the individuals and call them by the aggregate label
// only one entry so far because the section definitions suffice for the rest
export const aggregateLabels = {
    "the primary survey": ["primary-survey"],
    "the ABCs": ["airway", "breathing", "circulation"],
    "the secondary survey": ["secondary-assessment","head", "neck", "chest", "abdomen-pelvis", "assess-pelvis", "extremities", "posterior"]
}    


// defines what set of assessments can comprise an assessment step.  The key is the assessement step and the
// value is an array of the assessments that can comprise it.  Use this to infer if we can infer the step 
// should be counted as completed

// set up with a list of alternative contexts that could occur, any of which would count as allowing the inference

export const comprises = {
    "required-action-obtains-vitals": {type: "initial vitals", prepend: "request-vitals", op: "and", args: ["P", "R", "BP", "SpO2"]},
    "required-action-attempt-obtain-sample": {type: "sample", prepend: "request-sample", op: "or", args: ["S", "A", "M", "P", "L", "E"]},
    "required-action-obtain-OPQRST": {type: "opqrst", prepend: "request-opqrst", op: "or", args: ["O", "P", "Q", "R", "S", "T"]},
    "reassess-vital-signs": {type: "reassessment vitals", prepend: "request-vitals", op: "and", args: []} //args for reassessment vitals are scenario specific and will be supplied at runtime

    }


// defines which assessment steps are not required per scenario.  Provides feedback on
// why the step is not required.
export const exceptionDefs = 
[{scenarioName: "M2CA", exceptions: [
    //there is a bystander but wouldn't know about any earlier pain before accident
    ["required-action-obtain-OPQRST", "This cannot be assessed when GCS < 15"],
    ["assess-opqrst-info", "This cannot be assessed when GCS < 15"]
    ]},
    //removed below because there is a bystander who may have info about any pain before accident
 /* {scenarioName: "SC8CP", exceptions: [
        ["required-action-obtain-OPQRST", "This cannot be assessed when GCS < 15"],
        ["assess-opqrst-info", "This cannot be assessed when GCS < 15"]
        ]} */
  ]
  
/* This starts section on defining temporal constraints, conditional constraints and implications.*/

/*temporal constraints are an
index of event labels with two lists as values.
The first value is a list of event labels that the indexed event
should precede (if any) and the second value is a list of event
labels that the indexed event should follow after (if any)
*/

export const globalConstraints = {
    // event < list of other events (if in observation), > list of other events (if in observation)
    // lookup by event id to see the list of event ids that it should go before
    // and after (if in the observation), and the type of constraint. 
    // included constraints type with values of nonLeaf, leafI, leafA.  These are used to indicate the types of the arguments which
    // helps when providing feedback.  Phrase arguments are nonLeaf, intervention arguments are leafI and assessment arguments are
    // leafA.  An operator can be blank if only one item is listed for the
    // before or for the after. Note that a limitation is that all arguments must be of the same type and currently all are assumed to
    // use the same operator with respect to the 1st argument.  It may be better to rewrite the constraint representation to have a 
    // single constraint expressed per arguments and assume all multiple arguments in before and after default to "and" since that is 
    // really just a shorthand convenience

    //Note that: 
    //- for now the software will use either the label or id to lookup constraints but id
    // is preferred.  This was done for backward compatibility only when ids were being modified but
    // labels were not.
    //- a key (first item on each line) is the first arg in the constraint and is
    //  assumed to have just one constraint applicable to
    //  it but may appear as the second arg in another constraint multiple times (2nd args are
    //  lists under before or after fields)
    //- all afters are rewritten as befores within the initialization process to simplify the constraint checking
    //  software
    //- when something is a phase or subphase with multiple actions then we look for the begining
    //  and ending actions for constraint checking.  If overlap in phases is to be allowed the constraint should
    //  be amongst lower level items and no higher level constraint should be included
    //- there is no check to make sure the constraints expressed do not conflict.  For example,
    //  saying a whole phase should be before another phase and that a particular item in the second
    //  phase can go before some other item in the first phase are in conflict with one another


    // Should change to allow multiple constraints to be listed under a single arg1 lookup key.  Don't need a
    // lookup key for every constraint because if one of args is not present then the constraint doesn't need to
    // be tested.  Note, that there could be modifications needed when adding specific conditional constraints.  
    // Currently takes advantage of one key and one constraint so would need to remove conflicting constraints or 
    // specify which to global constraint to remove as part of conditional constraints rep.  May want to put 
    // operators between individual constraints if ever want to add commonsense constraints as in commented out 
    // T15 below.  Could then assume the list of before and after arguments are all "ands" since is provided 
    // just has a shorthand that gets expanded into two argument constraints.

    //"": {id: "T", before: [""], beforeOp: "", after: [], afterOp: "", type: "nonLeaf"},

    
    // T1
    "scene-size-up": {id: "T1", before: ["primary-survey"], beforeOp: "", after: [], afterOp: "", type: "nonLeaf"},
    // T2
    "abdomen-pelvis": {id: "T2", before: [], beforeOp: "", 
        after: ["primary-survey", "intv-open-airway-method-head-tilt","intv-open-airway-method-modified-jaw-thrust","intv-manual-finger-sweep","intv-magill-forceps-assisted","intv-heimlich-maneuver",
        "intv-back-blows-and-chest-thrusts", "intv-needle-cricothyrotomy", "intv-surgical-cricothyrotomy", "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
         "intv-position-patient", "intv-control-severe-bleeding-technique-direct-pressure",
        "intv-control-severe-bleeding-technique-2nd-tourniquet", "intv-control-severe-bleeding-technique-tourniquet", "intv-control-severe-bleeding-technique-pressure-bandage",
        "intv-insert-advanced-airway", "intv-sedation-assisted-intubation", "intv-nasotracheal-intubation", "intv-orotracheal-intubation"], afterOp: "and", type: "nonLeaf"},
    "assess-pelvis": {id: "T2", before: [], beforeOp: "", 
        after: ["primary-survey", "intv-open-airway-method-head-tilt","intv-open-airway-method-modified-jaw-thrust","intv-manual-finger-sweep","intv-magill-forceps-assisted","intv-heimlich-maneuver",
        "intv-back-blows-and-chest-thrusts", "intv-needle-cricothyrotomy", "intv-surgical-cricothyrotomy", "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
         "intv-position-patient", "intv-control-severe-bleeding-technique-direct-pressure",
        "intv-control-severe-bleeding-technique-2nd-tourniquet", "intv-control-severe-bleeding-technique-tourniquet", "intv-control-severe-bleeding-technique-pressure-bandage",
        "intv-insert-advanced-airway", "intv-sedation-assisted-intubation", "intv-nasotracheal-intubation", "intv-orotracheal-intubation"], afterOp: "and", type: "nonLeaf"},
    "extremities": {id: "T2", before: [], beforeOp: "", 
        after: ["primary-survey", "intv-open-airway-method-head-tilt","intv-open-airway-method-modified-jaw-thrust","intv-manual-finger-sweep","intv-magill-forceps-assisted","intv-heimlich-maneuver",
        "intv-back-blows-and-chest-thrusts", "intv-needle-cricothyrotomy", "intv-surgical-cricothyrotomy", "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
         "intv-position-patient", "intv-control-severe-bleeding-technique-direct-pressure",
        "intv-control-severe-bleeding-technique-2nd-tourniquet", "intv-control-severe-bleeding-technique-tourniquet", "intv-control-severe-bleeding-technique-pressure-bandage",
        "intv-insert-advanced-airway", "intv-sedation-assisted-intubation", "intv-nasotracheal-intubation", "intv-orotracheal-intubation"], afterOp: "and", type: "nonLeaf"},
    "posterior": {id: "T2", before: [], beforeOp: "", 
        after: ["primary-survey", "intv-open-airway-method-head-tilt","intv-open-airway-method-modified-jaw-thrust","intv-manual-finger-sweep","intv-magill-forceps-assisted","intv-heimlich-maneuver",
        "intv-back-blows-and-chest-thrusts", "intv-needle-cricothyrotomy", "intv-surgical-cricothyrotomy", "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
         "intv-position-patient", "intv-control-severe-bleeding-technique-direct-pressure",
        "intv-control-severe-bleeding-technique-2nd-tourniquet", "intv-control-severe-bleeding-technique-tourniquet", "intv-control-severe-bleeding-technique-pressure-bandage",
        "intv-insert-advanced-airway", "intv-sedation-assisted-intubation", "intv-nasotracheal-intubation", "intv-orotracheal-intubation"], afterOp: "and", type: "nonLeaf"},

    // T3
    "ints-call-for-helicopter": {id: "T3", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
    "intv-call-for-air-ambulance": {id: "T3", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},

    // T4
    //"required-action-obtains-vitals": {id: "T4", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafA"},
    // T5
    //"required-action-attempt-obtain-sample": {id: "T5", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafA"},
    // T6 
    //"required-action-obtain-OPQRST": {id: "T6", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafA"},
    // T7
    "intv-transport": {id: "T7", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: ["airway", "breathing", "circulation"], afterOp: "and", type: "leafI"},
    // T8
    "exposes-body-parts": {id: "T8", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafA"},
    // T9
    "general-impression": {id: "T9", before: ["airway", "breathing", "circulation"], beforeOp: "and", after: [], afterOp: "", type: "nonLeaf"},
    // T10
    "intv-spinal-immobilization-technique-manual-c-spine": {id: "T10-T27", before: ["airway","breathing", "circulation", "intv-spinal-immobilization-technique-cervical-collar"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
    // T11 was deleted per discussion with Sandy
    // T12 is in scenario specific constraints
    // T13 
    "intv-airway-patency-technique-suction-airway": {id: "T13", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
    // T14  deleted
    //"intv-airway-patency-technique-suction-airway": {id: "14", before: ["intv-oropharyngeal-airway", "intv-nasopharyngeal-airway"], beforeOp: "and", after: ["airway"], afterOp: "", type: "leafI"},
    // T15  deleted
    /* "intv-oropharyngeal-airway": {id: "T15", before: ["intv-nasotracheal-intubation", "intv-orotracheal-intubation", "intv-sedation-assisted-intubation", 
                                  "intv-rapid-sequence-intubation"], beforeOp: "or", after: [], afterOp: "", type: "leafI"},
    "intv-nasopharyngeal-airway": {id: "T15", before: ["intv-nasotracheal-intubation", "intv-orotracheal-intubation", "intv-sedation-assisted-intubation", 
                                  "intv-rapid-sequence-intubation"], beforeOp: "or", after: [], afterOp: "", type: "leafI"},
 */    // T16 awaiting observer interface implementation decisions on how contacting medical command will be recorded
    // T17
    "intv-ventilation-technique-bag-valve-mask": {id: "T17", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
    // T18 and T19 are constraints involving interventions that have been deleted
    // T20 see T2
    // T27 see T10
    // T28
    "intv-oropharyngeal-airway": {id: "T28", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"}, 
    "intv-nasopharyngeal-airway": {id: "T28", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
     // T29
    "intv-supplemental-oxygen-device-nasal-cannula": {id: "T29", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"}, 
    // T30
    "intv-supplemental-oxygen-device-non-rebreather-mask": {id: "T30", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"}, 
    // T34
    "intv-pleural-decompression": {id: "T34", before: ["abdomen-pelvis","assess-pelvis","extremities","posterior"], beforeOp: "and", after: [], afterOp: "", type: "leafI"},
         
}

//constraints that depend on whether certain conditions hold within a scenario
//based on the scenario and the constraint ids listed under the scenario in
//scenarioConstraintIDs, the constaints defined here with the ids for the current
//scenario will be added to the general constraints about for temporal constraint testing

// Used convention of appended -c and a one up number just to indicate it is a conditional constraint.  No software
// requires this convention for the ids so it can be changed

export const conditionalConstraints = {
    "checks-pulse-rate": {id: "T12-c1", before: ["airway"], beforeOp: "", after: [], afterOp: "", type: "leafA"},
    "checks-pulse-rhythm": {id: "T12-c2", before: ["airway"], beforeOp: "", after: [], afterOp: "", type: "leafA"},
    "checks-pulse-quality": {id: "T12-c3", before: ["airway"], beforeOp: "", after: [], afterOp: "", type: "leafA"}
    
    
}



// used to simulate conditional constraints, i.e. we hardcode which conditional constraint ids as
// defined under conditionalConstraints (above) are relevant to each scenario

// although one could put global constraint ids under scenarios here, it would be redundant and may cause software
// issues
export const scenarioConstraintIDs = {
    //training
    "B4CA": [],
    "B5CA": [],
    "C5CA": [],
    "SC8CP": ["T12-c1"],
    //test
    "B1CA": [],
    "M1CA": [], 
    "M2CA": ["T12-c1"],
    "B7CA": [],
    
}


//below are examples of interventions in which status should be checked.  The key intvStatusNeeded
//is true or false.  If true it means should have requested status of this intervention.  If vitals key is
//not empty then should have checked all of these vitals as well.  Will only check entries after an intervention
//up until something other than an intervention check is done

//Not currently issuing intervention specific reminders for what vitals need to be checked, so those are all blank right now
//Instead doing it per scenario
export const intvChecks = {
    "intv-open-airway-method-head-tilt": {intvStatusNeeded: false, vitalsNeeded: []},
    "intv-open-airway-method-modified-jaw-thrust": {intvStatusNeeded: false, vitalsNeeded: []},
    "intv-airway-patency-technique-suction-airway": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-manual-finger-sweep": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-magill-forceps-assisted": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-heimlich-maneuver": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-back-blows-and-chest-thrusts": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-oropharyngeal-airway": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-nasopharyngeal-airway": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-orotracheal-intubation": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-nasotracheal-intubation": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-insert-advanced-airway": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-sedation-assisted-intubation": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-needle-cricothyrotomy": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-surgical-cricothyrotomy": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-control-severe-bleeding-technique-direct-pressure": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-control-severe-bleeding-technique-tourniquet": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-control-severe-bleeding-technique-2nd-tourniquet": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-control-severe-bleeding-technique-pack-wound-with-gauze": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-control-severe-bleeding-technique-pressure-bandage": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-occlusive-dressing": {intvStatusNeeded: false, vitalsNeeded: []},
    "intv-pleural-decompression": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-prepare-and-administer-pain-nausea-vomiting-medications": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-insert-advanced-airway": {intvStatusNeeded: true, vitalsNeeded: []},
    "intv-contact-medical-command": {intvStatusNeeded: true, vitalsNeeded: []},

    // in general don't need to list if intvStatusNeeded is false but left these in in case want to use the
    // vitalsNeeded field for these later on to do the reminder intervention by intervention
    //"intv-supplemental-oxygen-device-nasal-cannula": {intvStatusNeeded: false, vitalsNeeded: []},
    //"intv-supplemental-oxygen-device-non-rebreather-mask": {intvStatusNeeded: false, vitalsNeeded: []},
    //"intv-ventilation-technique-bag-valve-mask": {intvStatusNeeded: false, vitalsNeeded: []},
    
 
    //"": {intvStatusNeeded: true, vitalsNeeded: []},  
    //"": {intvStatusNeeded: true, vitalsNeeded: []},
    
        
    }

// this is the name of the assessment step or phase that will use for inserting global vitals check feedback
// use one or the other constants below but not both
// Use this one for inserting in a phase header
export const vitalsCheckFeedbackLabel = undefined
//= "Ongoing Management & Reassessment"
// Use this one for inserting in a step
export const vitalsCheckFeedbackID = "reassess-vital-signs"


export const vitalChecks = {
    //pretraining
    "B3NA (practice)": [],
    //training
    "B4CA": ["P", "R", "SpO2"],
    "B5CA": ["BP", "P", "R", "SpO2"],
    "C5CA": ["BP", "P", "R", "SpO2"],
    "SC8CP": ["BP", "P", "R", "SpO2"],
    //test
    "B1CA": ["BP", "P", "R", "SpO2"],
    "M1CA": ["BP", "P", "R", "SpO2"],
    "M2CA": ["BP", "P", "R", "SpO2"],
    "B7CA": ["BP", "P", "R", "SpO2"],     
}

//the two below expand the above and could eliminate the above
//need to write the software to handle these two structures instead of the above
export const globalReassessmentKn = {
    //pretraining
    "B3NA (practice)": {vitalLabels: [], requiredVitals: "", systems: "", criticalInterventions: ""},
    //training
    "B4CA": {vitalLabels: ["P", "R", "SpO2"], requiredVitals: "P, R, and SpO2", systems: "breathing was", criticalInterventions: "high flow O2 via nasal cannula or NRM"},   
    "B5CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "breathing was", criticalInterventions: "high flow O2 with NRM or nasal cannula, needle decompression and an occlusive dressing"},
    "C5CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "circulation and breathing were, ", criticalInterventions: "direct pressure and a tourniquet, a basic adjunct (NPA), BVM ventilations with high-flow O2, and IV fluids en route to maintain SBP >= 90"},
    "SC8CP": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "airway and breathing were", criticalInterventions: "suctioning, intubation, and BVM ventilation with high concentration O2"},
    //test
    "B1CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "breathing was", criticalInterventions: "NPA, BVM ventilation with high flow O2, and needle decompression with an occlusive dressing"},
    "M1CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "airway and circulation were", criticalInterventions: "occlusive dressing on neck wound, basic airway maneuver, an NPA, BVM ventilation with high flow O2 and IV fluids en route"},
    "M2CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "airway, breathing and circulation were", criticalInterventions: "direct pressure, a tourniquet, basic airway maneuver, intubation, an NPA or OPA, BVM ventilation with high flow O2, a large bore IV and IV fluids en route to maintain SBP >= 90"},
    "B7CA": {vitalLabels: ["BP", "P", "R", "SpO2"], requiredVitals: "BP, P, R, and SpO2", systems: "breathing was", criticalInterventions: "supplemental O2 via NRM or nasal cannula, pleural decompression and an occlusive dressing to the entrance wound "},
}

export const globalReassessmentFeedback = {
    good:   "This patient had several abnormal baseline vitals-most notably @requiredVitals +bos The patient needed @criticalInterventions +bos You correctly checked an initial set of these vitals and then checked that they improved to ensure that the patient's @systems adequately managed +eos",
    errors: "This patient had several abnormal baseline vitals-most notably @requiredVitals +bos The patient needed @criticalInterventions +bos You should have taken an initial set of these vitals and then checked that they improved to ensure that the patient's @systems adequately managed +bos You missed fully checking @notDone +eos",
    absent: "This patient had several abnormal baseline vitals-most notably @requiredVitals +bos The patient needed @criticalInterventions +bos You should have taken an initial set of these vitals and then checked that they improved to ensure that the patient's @systems adequately managed +eos"
}

export const vitalsFeedback = {
    good: "You correctly obtained an initial reading for the vital(s) @done +eos",
    errors: "You correctly obtained an initial reading for the vital(s) @done but you should have also done so for the vital(s) @notDone +eos",
    absent: "You should always obtain an initial reading for the vitals @notDone +eos",
}

//vitals, sample, opqrst that can be inferred to have been taken due to an
//assessment step.  However, for assessment steps the findings
//are not actual taking of vitals but a quick subjective impression
//so this is no longer in use.
//at top level [] read as an "or"
//at next level [] read as an "and"
// above fields no longer fully used.  Only indicates which id relates to which vital
// at this point
export const vitalsToStep = {
    "GCS": [//["assess-loc"], ["required-action-obtains-vitals"],
    ["request-vitals-GCS"]],
    "Pain": [//["assess-loc"], ["required-action-obtains-vitals"], 
    ["request-vitals-Pain"]],
    "R": [//["breathing-checks-rate", "breathing-checks-rhythm", "breathing-checks-quality"], ["required-action-obtains-vitals"], 
    ["request-vitals-R"]],
    "P": [//["checked-carotid-pulse", "checks-pulse-rate", "checks-pulse-rhythm", "checks-pulse-quality"], ["checked-radial-pulse", "checks-pulse-rate", "checks-pulse-rhythm", "checks-pulse-quality"],["required-action-obtains-vitals"], 
    ["request-vitals-P"]],
    "Skin": [//["checks-skin-color", "checks-skin-temperature", "checks-skin-condition"], ["required-action-obtains-vitals"], 
    ["request-vitals-Skin"]],
    "BP": [//["required-action-obtains-vitals"], 
    ["request-vitals-BP"]],
    "Glucose": [//["required-action-obtains-vitals"], 
    ["request-vitals-Glucose"]],
    "ETCO2": [//["required-action-obtains-vitals"], 
    ["request-vitals-ETCO2"]],
    "SpO2": [//["required-action-obtains-vitals"], 
    ["request-vitals-SpO2"],["request-vitals-Spo2"]],  //in some places I saw SpO2 and some Spo2 so putting in both
    "Temp": [//["required-action-obtains-vitals"], 
    ["request-vitals-Temp"]]}

export const sampleToStep = {
    "S": [["request-sample-S"]],
    "A": [["request-sample-A"]],
    "M": [["request-sample-M"]],
    "P": [["request-sample-P"]],
    "L": [["request-sample-L"]],
    "E": [["request-sample-E"]]}
    
export const opqrstToStep = {
    "O": [["request-opqrst-O"]],
    "P": [["request-opqrst-P"]],
    "Q": [["request-opqrst-Q"]],
    "R": [["request-opqrst-R"]],
    "S": [["request-opqrst-S"]],
    "T": [["request-opqrst-T"]],
    }

//per scenario sets of interventions that satisfy completion of critical actions for that scenario
// to update vitals wholesale
export const criticalInterventions = {
    //pretraining scenario
    "B3NA (practice)": [],
    
    //training scenarios
    B4CA: [["intv-supplemental-oxygen-device-nasal-cannula"],
           ["intv-supplemental-oxygen-device-non-rebreather-mask"]],
    B5CA: [["intv-supplemental-oxygen-device-nasal-cannula","intv-occlusive-dressing", "intv-pleural-decompression"], 
           ["intv-supplemental-oxygen-device-non-rebreather-mask","intv-occlusive-dressing", "intv-pleural-decompression"]],
    C5CA: [["intv-control-severe-bleeding-technique-tourniquet",
            "intv-nasopharyngeal-airway", "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"]],
    SC8CP: [
    ["intv-airway-patency-technique-suction-airway", "intv-oropharyngeal-airway", "intv-orotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
    ["intv-airway-patency-technique-suction-airway", "intv-oropharyngeal-airway", "intv-nasotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
    ["intv-airway-patency-technique-suction-airway", "intv-oropharyngeal-airway", "intv-insert-advanced-airway", "intv-ventilation-technique-bag-valve-mask"],
    ["intv-airway-patency-technique-suction-airway", "intv-nasopharyngeal-airway", "intv-orotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
    ["intv-airway-patency-technique-suction-airway", "intv-nasopharyngeal-airway", "intv-nasotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
    ["intv-airway-patency-technique-suction-airway", "intv-nasopharyngeal-airway", "intv-insert-advanced-airway", "intv-ventilation-technique-bag-valve-mask"],
    ],
    //test scenarios
    B1CA: [["intv-supplemental-oxygen-device-non-rebreather-mask", "intv-pleural-decompression"]],
    M1CA: [["intv-occlusive-dressing", "intv-sedation-assisted-intubation", "intv-control-shock-technique-administer-iv-boluses", 
           "intv-ventilation-technique-bag-valve-mask"],],
    M2CA: [
    ["intv-control-severe-bleeding-technique-tourniquet",
        "intv-nasopharyngeal-airway","intv-orotracheal-intubation",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"],
    ["intv-control-severe-bleeding-technique-tourniquet",
        "intv-nasopharyngeal-airway","intv-nasotracheal-intubation",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"],
    ["intv-control-severe-bleeding-technique-direct-pressure", "intv-control-severe-bleeding-technique-tourniquet",
        "intv-nasopharyngeal-airway","intv-insert-advanced-airway",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"],   
    ["intv-control-severe-bleeding-technique-tourniquet",
        "intv-oropharyngeal-airway","intv-orotracheal-intubation",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"],
    ["intv-control-severe-bleeding-technique-tourniquet",
        "intv-oropharyngeal-airway","intv-nasotracheal-intubation",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"],
    ["intv-control-severe-bleeding-technique-direct-pressure", "intv-control-severe-bleeding-technique-tourniquet",
        "intv-oropharyngeal-airway","intv-insert-advanced-airway",
        "intv-ventilation-technique-bag-valve-mask", "intv-control-shock-technique-administer-iv-boluses"]],
    B7CA: [["intv-supplemental-oxygen-device-non-rebreather-mask", "intv-pleural-decompression", "intv-occlusive-dressing"],
           ["intv-supplemental-oxygen-device-nasal-cannula", "intv-pleural-decompression", "intv-occlusive-dressing"]]
}

//could create a set of default good values but sounds like will
//want to customize the descriptive text per scenario (and may not
//always want the completely good value as an effect)


//each scenario entry is a list of rules
//each rule is an object with the ands field being any other interventions that must have also been done to
//qualify doing the update in field updates.
//the updates field is a list of pairs of assessment ids and the value to update in that assessments findings field

//Note that each member of the ands field has its own set of rules in this table.  Only one of the rules will "fire"
//but is repeated because we don't know the order in which the interventions may be done

//rule template
/*
[
    {ands: [""],
    updates: [["",""]]}
], 
*/


//what assessment findings to update due to interventions
//rules per table in document Updating.callouts.after.interventions-v4 
export const intvStatusRules = {
    //pretrainting scenario
   
    "B3NA (practice)": [],  //has no update rules


    //training scenarios

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    B4CA:
        [
            {
                ands: ["intv-supplemental-oxygen-device-nasal-cannula"],
                updates: [{ id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "less rapid" },]
            },

            {
                ands: ["intv-supplemental-oxygen-device-non-rebreather-mask"],
                updates: [{ id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "less rapid" },]
            }
        ],

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    B5CA:

        [
            {
                ands: ["intv-supplemental-oxygen-device-non-rebreather-mask", "intv-pleural-decompression", "intv-occlusive-dressing"],
                //first one where id is "", will only update tab B, others will update in tabs indicated and in secondary assessments under id
                updates: [{ id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Regular" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "Asymmetric but increased LS on right" },
                { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Rate Normal; strong radial pulse" },
                { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Rate Normal; strong radial pulse" }]
            },

            {
                ands: ["intv-supplemental-oxygen-device-nasal-cannula", "intv-pleural-decompression", "intv-occlusive-dressing"],
                //first one where id is "", will only update tab B, others will update in tabs indicated and in secondary assessments under id
                updates: [{ id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Regular" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "Asymmetric but increased LS on right" },
                { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Rate Normal; strong radial pulse" },
                { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Rate Normal; strong radial pulse" }]
            },

            {
                ands: ["intv-occlusive-dressing"],
                updates: [{ id: "inspects-palpates-anterior-thorax", tab: ["C"], label: "Bleeding", val: "Occlusive dressing covers wound" }]
            }
        ],

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    C5CA:

        [
            {
                ands: ["intv-nasopharyngeal-airway", "intv-ventilation-technique-bag-valve-mask"],
                updates: [{ id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Breaths assisted; spontaneous, less rapid and shallow" }]
            },

            {
                ands: ["intv-control-severe-bleeding-technique-tourniquet"],
                updates: [{ id: "inspects-left-leg-injury", tab: ["C"], label: "Bleeding", val: "Bleeding stopped" }]
            },
        ],


    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    SC8CP:

        [
            //rule 1
            {
                ands: ["intv-airway-patency-technique-suction-airway"],
                updates: [{ id: "", tab: ["A"], label: "Clarity", val: "Clear of vomit and water" },
                { id: "inspects-mouth", tab: [], label: "Clarity", val: "Clear of vomit and water" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "No gurgling, rhonchi bilaterally" },]
            },

            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-nasopharyngeal-airway"],
                updates: [{ id: "", tab: ["A"], label: "Patency", val: "Clear and secured" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-oropharyngeal-airway"],
                updates: [{ id: "", tab: ["A"], label: "Patency", val: "Clear and secured" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-nasopharyngeal-airway", "intv-ventilation-technique-bag-valve-mask"],
                updates: [
                    { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Respirations assisted, gurgling stopped" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-oropharyngeal-airway", "intv-ventilation-technique-bag-valve-mask"],
                updates: [
                    { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Respirations assisted, gurgling stopped" },]
            },

            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-orotracheal-intubation", "intv-nasopharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-orotracheal-intubation", "intv-oropharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },



            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-nasotracheal-intubation", "intv-nasopharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-nasotracheal-intubation", "intv-oropharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },

            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-insert-advanced-airway", "intv-nasopharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },


            {
                ands: ["intv-open-airway-method-modified-jaw-thrust", "intv-airway-patency-technique-suction-airway", "intv-ventilation-technique-bag-valve-mask", "intv-insert-advanced-airway", "intv-oropharyngeal-airway"],
                updates: [
                    { id: "", tab: ["C"], label: "Pulse", val: "Regular, strong" },
                    { id: "checks-skin", tab: ["C"], label: "Skin", val: "Pale, cool, dry" },
                    { id: "inspects-right-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },
                    { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Regular, strong" },]
            },
        ],

    //test scenarios

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    B1CA:

        [
            {
                ands: ["intv-pleural-decompression", "intv-supplemental-oxygen-device-non-rebreather-mask"],
                updates: [{ id: "assess-loc", tab: ["General"], label: "Mental status", val: "Responds verbally; speaks more comfortably" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "Equal LS bilaterally" },
                { id: "assessment-JVD", tab: ["C"], label: "JVD", val: "No JVD" },
                { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Less rapid, regular, equal LS bilaterally" },
                { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, regular, strong " },
                { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, regular, strong " },
                { id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
                { id: "assessment-JVD", tab: ["C"], label: "JVD", val: "No JVD" },]
            },

        ],

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    B7CA:

        [
            {
                ands: ["intv-supplemental-oxygen-device-non-rebreather-mask", "intv-pleural-decompression", "intv-occlusive-dressing"],
                updates: [{ id: "", tab: ["General"], label: "Mental status", val: "Alert; less anxious" },
                { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Less rapid, breath sounds improved on right though still diminished at right base" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "LS present but diminished in the right base" },
                { id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
                { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" }]
            },

            {
                ands: ["intv-supplemental-oxygen-device-nasal-cannula", "intv-pleural-decompression", "intv-occlusive-dressing"],
                updates: [{ id: "", tab: ["General"], label: "Mental status", val: "Alert; less anxious" },
                { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Less rapid, breath sounds improved on right though still diminished at right base" },
                { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "LS present but diminished in the right base" },
                { id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
                { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" },
                { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, regular" }]
            },

            {
                ands: ["intv-occlusive-dressing"],
                updates: [{ id: "inspects-palpates-anterior-thorax", tab: ["C"], label: "Bleeding", val: "Occlusive dressing over GSW" },]
            },
        ],

    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    M1CA:

        [{
            ands: ["intv-sedation-assisted-intubation", "intv-ventilation-technique-bag-valve-mask"],
            updates: [{ id: "", tab: ["General"], label: "Mental Status", val: "Becoming more alert" },
            { id: "", tab: ["A"], label: "Patency", val: "Secured with ET tube in place" },
            { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Assisted breaths" },
            { id: "assessment-check-breath-sounds", tab: ["B"], label: "Lung sounds", val: "No stridor, LS equal and clear" },]
        },


        {
            ands: ["intv-ventilation-technique-bag-valve-mask"],
            updates: [{ id: "assess-loc", tab: ["General"], label: "Mental Status", val: "Becoming more alert" },
            { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Assisted breaths" },]
        },


        ], 
        
        
    //{ands: [], updates: []},
    //{id: "", tab: [""], label: "", val: ""},
    M2CA:

        [{
            ands: ["intv-orotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
            updates: [
                { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Assisted breaths" },]
        },

        {
            ands: ["intv-nasotracheal-intubation", "intv-ventilation-technique-bag-valve-mask"],
            updates: [
                { id: "", tab: ["B"], label: "Rate, rhythm, quality", val: "Assisted breaths" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-oropharyngeal-airway", "intv-nasotracheal-intubation"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-oropharyngeal-airway", "intv-orotracheal-intubation"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-oropharyngeal-airway", "intv-insert-advanced-airway"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-nasopharyngeal-airway", "intv-nasotracheal-intubation"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-nasopharyngeal-airway", "intv-orotracheal-intubation"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },

        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet", "intv-ventilation-technique-bag-valve-mask",
                "intv-control-shock-technique-administer-iv-boluses", "intv-nasopharyngeal-airway", "intv-insert-advanced-airway"],
            updates: [{ id: "", tab: ["C"], label: "Skin", val: "Pale, diaphoretic" },
            { id: "inspects-right-arm-pulse", tab: ["C"], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-arm-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-left-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },
            { id: "inspects-right-leg-pulse", tab: [], label: "Pulse", val: "Less rapid, becoming stronger" },]
        },


        {
            ands: ["intv-control-severe-bleeding-technique-tourniquet"],
            updates: [{ id: "inspects-right-leg-injury", tab: ["C"], label: "Bleeding", val: "No further bleeding" },]
        },

        ],  
    
    }


//this section defines intervention status changes per scenario
//first define categories of states
export const airwayOpen = "airwayOpen"
export const airwayPatent = "airwayPatent"
export const airwayAdjunct = "airwayAdjunct"
export const airwaySecured = "airwaySecured"
export const intubation = "intubation"
export const airwayProcedure = "airwayProcedure"
export const circulationPressure = "circulationPressure"
export const circulationTourniquet = "circulationTourniquet"
export const breathSounds = "breathSounds"
export const medEffects = "medEffects"
export const medCommandApproval = "medCommandApproval"

//newly added 10/7/22
export const oxygenated = "oxygenated"
export const decompression = "decompression"
export const medAdmin = "medAdmin"
export const receivingFacilityReply= "receivingFacilityReply"
export const shockWarming = "shockWarming"
export const ivPlacement = "ivPlacement"
export const patientPositionPlacement = "patientPositionPlacement"
export const airAmbulance = "airAmbulance"
export const  woundState = "woundState"
export const notAllowed = "notAllowed"
export const breathingAssisted = "breathingAssisted"
export const inRoute = "inRoute"
export const cSpineCollar = "cSpineCollar"
export const spineStable = "spineStable"
export const injuryStable = "injuryStable"
export const  onStretcher = "onStretcher"
export const amputated = "amputated"
export const fracture = "fracture"
export const sling = "sling"

//added 2/6/23
export const ivFluidTherapy = "ivFluidTherapy"
export const cardiacMonitoring = "cardiacMonitoring"

//export const  = ""


export const good = "good"
export const neutral = "neutral"
export const bad = "bad"

//define for each state categories the description to use for an intervention that results
//in a good, bad or neutral change of state relative to some unknown initial state
export const interventionStates = Object.freeze({
    airwayOpen: {good: "airway open", neutral: "airway open", bad: "no change"},
    airwayPatent: {good: "airway cleared", neutral: "no change", bad: "no change"},
    airwayAdjunct: {good: "accepted, airway secured", neutral: "accepted, airway secured", bad: "rejected"},
    airwaySecured: {good: "airway secured", neutral: "airway secured", bad: "airway not secured"},
    intubation: {good: "tube properly placed, airway secured, bilateral lung sounds, no gastric sounds",
        neutral: "tube properly placed, airway secured, bilateral lung sounds, no gastric sounds",
        bad: "tube rejected"},
    airwayProcedure: {good: "successful, airway secured, chest rise and fall present",
                      neutral: "successful, airway secured, chest rise and fall present",
                      bad: "unsuccessful"},
    oxygenated: {good: "oxygenation in progress", neutral: "oxygenation in progress", bad: "patient not oxygenated"},
    circulationPressure: {good: "bleeding slowed", neutral: "no change", bad: "no change"},
    circulationTourniquet: {good: "bleeding controlled, pulse absent", neutral: "no change", bad: "no change"},
    breathSounds: {good: "breath sounds bilateral", neutral: "no change", bad: "no change"},
    decompression: {good: "rush of air heard", neutral: "air release not heard", bad: "air release not heard"},
    medEffects: {good: "medication taking effect", neutral: "medication taking effect", bad: "medication administered"},
    medAdmin: {good: "meds administered", neutral: "meds administered", bad: "meds not administered"},
    medCommandApproval: {good: "request approved or advice provided", neutral: "request approved or advice provided", bad: "request denied"},
    receivingFacilityReply: {good: "report received", neutral: "report received", bad: "report received"},
    shockWarming: {good: "body temp. being controlled", neutral: "body temp. being controlled", bad: "body temp. not being controlled"},
    ivPlacement: {good: "properly placed", neutral: "properly placed", bad: "improperly placed"}, 
    ivFluidTherapy: {good: "fluid therapy in progress", neutral: "fluid therapy in progress", bad: "fluid therapy not in progress"},
    patientPositionPlacement: {good: "patient in intended position", neutral: "patient in intended position", bad: "patient not in intended position"},
    airAmbulance: {good: "STAT MedEvac on the way", neutral: "STAT MedEvac on the way", bad: "STAT MedEvac not available"},
    woundState: {good: "wound covered", neutral: "dressing applied", bad: "dressing applied"},
    notAllowed: {good: "not in EMT-P scope of practice", neutral: "not in EMT-P scope of practice", bad: "not in EMT-P scope of practice"},
    breathingAssisted: {good: "breathing assisted", neutral: "breathing assisted", bad: "breathing not assisted"},
    inRoute: {good: "en route to hospital", neutral: "en route to hospital", bad: "not en route to hospital"},
    cSpineCollar: {good: "collar properly placed", neutral: "collar properly placed", bad: "collar improperly placed"},
    spineStable: {good: "head and neck stablized", neutral: "head and neck stablized", bad: "head and neck not stablized"},
    injuryStable: {good: "injury stablized", neutral: "injury stablized", bad: "injury not stablized"},
    sling: {good: "wound stabilized", neutral: "securely placed", bad: "wound not stablized"},
    onStretcher: {good: "patient on stretcher", neutral: "patient on stretcher", bad: "patient not on stretcher"},
    amputated: {good: "severed part ready for transport", neutral: "not Found", bad: "not Found"},
    fracture: {good: "fracture stabilized", neutral: "securely placed", bad: "fracture not stablized"},
    patientPositionPlacement: {good: "patient in intended position", neutral: "patient in intended position", bad: "patient not in intended position"},
    cardiacMonitoring: {good: "leads in place", neutral: "leads in place", bad: "leads not in place"},
     //: {good: "", neutral: "", bad: ""},  
               
})

// The actual "rules" for what update to make per intervention status values per scenario

// - good if the intervention should be done to change a bad initial patient status (but doesn't mean it is the correct one to do) 
//   or the initial patient status is already fine (latter could be coded as neutral instead), 
// - bad if the intervention can effect a bad initial patient status but would not change it in this case or if it won't work for other reasons, (this one 
//   could be a problem rule of thumb if e.g. student applied a tourniquet and then applied direct pressure, might be safer to use neutral in some cases)
// - neutral if initial patient status is bad and this intervention would have no effect on the patient status
//   or if it is not indicated according to initial patient status (i.e. status is fine so doing this would not change the status)
export const intvResults = Object.freeze({
    "intv-open-airway-method-head-tilt": {type: airwayOpen, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
    "intv-open-airway-method-modified-jaw-thrust": {type: airwayOpen, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: good, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},
    "intv-needle-cricothyrotomy": { type: airwayOpen, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
    "intv-surgical-cricothyrotomy": {type: airwayOpen, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
    
  "intv-back-blows-and-chest-thrusts": {type: airwayPatent, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-manual-finger-sweep": {type: airwayPatent, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-magill-forceps-assisted": {type: airwayPatent, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-heimlich-maneuver": {type: airwayPatent, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-airway-patency-technique-suction-airway": {type: airwayPatent, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: good, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},

  //used bad for C5CA because assumed gag reflex would lead to rejection of oropharyngeal airway
  "intv-nasopharyngeal-airway": {type: airwayAdjunct, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: good, SC8CP: good, B1CA: neutral, M1CA: neutral, M2CA: good, B7CA: neutral},
  "intv-oropharyngeal-airway": {type: airwayAdjunct, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: bad, SC8CP: good, B1CA: bad, M1CA: bad, M2CA: good, B7CA: bad},
    
  "intv-rapid-sequence-intubation": {type: notAllowed, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},

  "intv-nasotracheal-intubation": {type: intubation, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: bad, SC8CP: good, B1CA: bad, M1CA: bad, M2CA: good, B7CA: bad},
  "intv-orotracheal-intubation": {type: intubation, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: bad, SC8CP: good, B1CA: bad, M1CA: bad, M2CA: good, B7CA: bad},
  "intv-sedation-assisted-intubation": {type: intubation, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: bad, SC8CP: bad, B1CA: bad, M1CA: good, M2CA: neutral, B7CA: bad},
  "intv-insert-advanced-airway": {type: intubation, "B3NA (practice)": bad, B4CA: bad, B5CA: bad, C5CA: bad, SC8CP: good, B1CA: bad, M1CA: good, M2CA: good, B7CA: bad},
 
  "intv-supplemental-oxygen-device-nasal-cannula": {type: oxygenated, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-supplemental-oxygen-device-non-rebreather-mask": {type: oxygenated, "B3NA (practice)": neutral, B4CA: good, B5CA: good, C5CA: neutral, SC8CP: neutral, B1CA: good, M1CA: neutral, M2CA: neutral, B7CA: good},
  
  "intv-ventilation-technique-bag-valve-mask": {type: breathingAssisted, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: good, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},
  
  "intv-control-severe-bleeding-technique-pressure-bandage": {type: circulationPressure, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},
  "intv-control-severe-bleeding-technique-direct-pressure": {type: circulationPressure, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},
  "intv-control-severe-bleeding-technique-pack-wound-with-gauze": {type: circulationPressure, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  
  "intv-control-severe-bleeding-technique-2nd-tourniquet": {type: circulationTourniquet, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-control-severe-bleeding-technique-tourniquet": {type: circulationTourniquet, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: good, B7CA: neutral},
  
  "intv-control-severe-bleeding-technique-load-and-go": {type: inRoute, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-transport": {type: inRoute, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},

  "intv-control-shock-technique-keep-patient-warm": {type: shockWarming, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},
  
  "intv-position-patient": {type: patientPositionPlacement, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  "intv-control-shock-technique-place-patient-supine-position" : {type: patientPositionPlacement, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  
  "intv-control-shock-technique-administer-iv-boluses": {type: ivFluidTherapy, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: good, M2CA: good, B7CA: neutral},

  "intv-establish-iv": {type: ivPlacement, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  
  "intv-occlusive-dressing": {type: woundState, "B3NA (practice)": neutral, B4CA: neutral, B5CA: good, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: good, M2CA: neutral, B7CA: good},
  "intv-apply-sterile-dressings": {type: woundState, "B3NA (practice)": neutral, B4CA: neutral, B5CA: good, C5CA: good, SC8CP: neutral, B1CA: neutral, M1CA: good, M2CA: neutral, B7CA: neutral},
  
  "intv-pleural-decompression": {type: decompression, "B3NA (practice)": neutral, B4CA: neutral, B5CA: good, C5CA: neutral, SC8CP: neutral, B1CA: good, M1CA: neutral, M2CA: neutral, B7CA: good},
  
  "intv-spinal-immobilization-technique-attach-cid": {type: spineStable, "B3NA (practice)": good, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: good, B1CA: good, M1CA: neutral, M2CA: good, B7CA: neutral},
  "intv-spinal-immobilization-technique-manual-c-spine": {type: spineStable, "B3NA (practice)": good, B4CA: good, B5CA: neutral, C5CA: good, SC8CP: good, B1CA: good, M1CA: neutral, M2CA: good, B7CA: neutral},

  "intv-spinal-immobilization-technique-cervical-collar": {type: cSpineCollar, "B3NA (practice)": good, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: good, B1CA: good, M1CA: neutral, M2CA: good, B7CA: neutral},
      
  "intv-prepare-and-administer-pain-nausea-vomiting-medications": {type: medEffects, "B3NA (practice)": neutral, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  
  "intv-contact-receiving-facility": {type: receivingFacilityReply, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  
  "intv-sling": {type: sling, "B3NA (practice)": neutral, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},    
  
  "intv-call-for-air-ambulance": {type: airAmbulance, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: good, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  
  "intv-contact-medical-command": {type: medCommandApproval, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  
  "intv-prepare-amputated-part": {type: amputated, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: good, B7CA: neutral},
  
  "intv-splint-fracture": {type: fracture, "B3NA (practice)": neutral, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  "intv-bulky-dressing": {type: fracture, "B3NA (practice)": neutral, B4CA: good, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: good, M1CA: neutral, M2CA: good, B7CA: neutral},
  
  "intv-place-directly-on-stretcher": {type: onStretcher, "B3NA (practice)": neutral, B4CA: neutral, B5CA: good, C5CA: good, SC8CP: good, B1CA: neutral, M1CA: good, M2CA: neutral, B7CA: good},
  "intv-place-on-immobilization-device": {type: onStretcher, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  "intv-walk-patient-to-ambulance": {type: onStretcher, "B3NA (practice)": neutral, B4CA: neutral, B5CA: neutral, C5CA: neutral, SC8CP: neutral, B1CA: neutral, M1CA: neutral, M2CA: neutral, B7CA: neutral},
  
  "intv-twelve-lead-placement": {type: cardiacMonitoring, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},
  "intv-four-lead-placement": {type: cardiacMonitoring, "B3NA (practice)": good, B4CA: good, B5CA: good, C5CA: good, SC8CP: good, B1CA: good, M1CA: good, M2CA: good, B7CA: good},

})

//all below is just for my editing purposes in the above structures
//commented out ones that don't impact assessment/status findings
const interventions = [

  "intv-open-airway-method-head-tilt",
  "intv-open-airway-method-modified-jaw-thrust",
  "intv-airway-patency-technique-suction-airway",
  "intv-manual-finger-sweep",
  "intv-magill-forceps-assisted",
  "intv-heimlich-maneuver",
  "intv-back-blows-and-chest-thrusts",
  "intv-oropharyngeal-airway",
  "intv-nasopharyngeal-airway",
  "intv-orotracheal-intubation",
  "intv-nasotracheal-intubation",
  //"intv-rapid-sequence-intubation",
  "intv-sedation-assisted-intubation",
  "intv-needle-cricothyrotomy",
  "intv-surgical-cricothyrotomy",
  "intv-supplemental-oxygen-device-nasal-cannula",
  "intv-supplemental-oxygen-device-non-rebreather-mask",
  "intv-ventilation-technique-bag-valve-mask",
  "intv-control-severe-bleeding-technique-direct-pressure",
  "intv-control-severe-bleeding-technique-tourniquet",
  "intv-control-severe-bleeding-technique-2nd-tourniquet",
  "intv-control-severe-bleeding-technique-pack-wound-with-gauze",
  "intv-control-severe-bleeding-technique-pressure-bandage",
  //"intv-control-severe-bleeding-technique-load-and-go",
  "intv-control-shock-technique-keep-patient-warm",
  //"intv-control-shock-technique-place-patient-supine-position",
  "intv-position-patient",
  "intv-control-shock-technique-administer-iv-boluses",
  "intv-occlusive-dressing",
  "intv-pleural-decompression",
  //"intv-spinal-immobilization-technique-manual-c-spine",
  //"intv-spinal-immobilization-technique-cervical-collar",
  //"intv-spinal-immobilization-technique-attach-cid",
  //"intv-transport",
  //"intv-apply-sterile-dressings",
  "intv-prepare-and-administer-pain-nausea-vomiting-medications",
  //"intv-contact-receiving-facility",
  //"intv-sling",
  "intv-insert-advanced-airway",
  //"intv-call-for-air-ambulance",
  //"intv-contact-medical-command",
  //"intv-establish-iv",
  //"intv-prepare-amputated-part",
  //"intv-splint-fracture",
  //"intv-place-on-immobilization-device",
  //"intv-walk-patient-to-ambulance",
  //"intv-place-directly-on-stretcher",
]